import { render, staticRenderFns } from "./StatementDetailView.vue?vue&type=template&id=e9bdf0f0&scoped=true"
import script from "./StatementDetailView.vue?vue&type=script&lang=js"
export * from "./StatementDetailView.vue?vue&type=script&lang=js"
import style0 from "./StatementDetailView.vue?vue&type=style&index=0&id=e9bdf0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bdf0f0",
  null
  
)

export default component.exports